// The one broker every embedded-app host registers its iframe with (VUE-9 â†’ Handshake).
import { EVENT_BUS } from "../common/constants";
import { getAuthConfig } from "./auth-helper";
import { axiosConfigurationHelper } from "./axios-helper";
import { EmbeddedAppTokenBroker, SignOutReason, TokenSnapshot } from "./embedded-app-token-broker";
import EventBus from "./event-bus";

export const embeddedAppTokenBroker = new EmbeddedAppTokenBroker({
    readToken: (): TokenSnapshot | null => {
        const config = getAuthConfig();
        return config.oauth2.accessToken
            ? {
                accessToken: config.oauth2.accessToken,
                accessTokenExpiration: config.oauth2.accessTokenExpiration || null,
                webApiEndPoint: config.information.webApiEndPoint,
                webApiVersion: config.information.webApiVersion,
                isMasterUser: config.IsMasterUser
            }
            : null;
    },
    refreshAccessToken: () => axiosConfigurationHelper()?.ensureFreshAccessToken() ?? Promise.resolve(null)
});

window.addEventListener("message", event => {
    embeddedAppTokenBroker.handleMessage(event).catch(error => console.error("[EmbeddedAppTokenBroker]", error));
});
EventBus.$on(EVENT_BUS.AUTH.STATE_CHANGED, () => embeddedAppTokenBroker.onTokenRefreshed());
EventBus.$on(EVENT_BUS.AUTH.SIGNED_OUT, (reason: SignOutReason) => embeddedAppTokenBroker.onSignedOut(reason));
